import {LandingPageRow} from "./LandingPageRow.js";

export class LandingPage{
    name:string="";
    rows:LandingPageRow[]=[];
}